import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedButtonComponent } from './shared-button.component'
import { TranslateModule } from '@ngx-translate/core'
import { ModalModule } from '../modal/modal.module'

@NgModule({
	declarations: [SharedButtonComponent],
	imports: [CommonModule, ModalModule, TranslateModule],
	exports: [SharedButtonComponent],
})
export class SharedButtonModule {}
